import { Layout, Icons, Button, Upload, Menu, Modal } from 'procredit-bank-design-system'
import { Row, Col } from 'procredit-bank-design-system';
import * as React from 'react';
import { useParams } from "react-router-dom";
import TransferModal from './Components/TransferModal';
import TransferTable from './Components/TransferTable';
import { saveAs } from 'file-saver';
import i18next, { t } from 'i18next';

const batchFilesPerCountry = [
  {
    Country: 'Macedonia',
    BatchTypes: ['Other', 'International']
  }
]


const { Header, Content } = Layout
const { PlusOutlined, UploadOutlined, ExportOutlined, CloseCircleFilled } = Icons;

const initialData: Array<any> = [
];

function App() {
  const { country, batchFileType } = useParams();
  let batchConfig: any;
  import(`./BatchData/${country}/${batchFileType}`).then(
    someModule => {
      setColumns(someModule.default.Columns);
      batchConfig = someModule.default;
    }
  )

  const [modalVisible, setModalVisible] = React.useState(false);
  const [data, setData] = React.useState([...initialData]);
  const [transfer, setTransfer] = React.useState({});
  const [columns, setColumns] = React.useState([]);

  const addTransfer = (key: any, newItem: any) => {
    let transfer = data.find(t => t.key === key);

    if (transfer) {
      let newData = data.map(i => i.key === key ? { key: key, ...newItem } : i);
      setData([...newData]);
    } else {
      newItem.key = data.length + 1;
      setData([...data, newItem]);
    }
    resetTransfer();
  }

  const removeTransfer = (key: string) => {
    setData(data.filter(i => i.key !== key));
  }

  const resetTransfer = () => {
    setTransfer({});
  }

  const editTransfer = (transfer: any) => {
    setTransfer(transfer);
  }

  const showModal = () => {
    setModalVisible(true)
  };

  const fileUploadHandler = (file: any, fileList: any) => {
    const fileParts = file.file.name.split('.');
    
    if (fileParts[fileParts.length - 1].toLowerCase() !== batchConfig.FileFormat){
      Modal.error({
        title: t('fileErrorTitle'),
        content: t('fileErrorIncorrectFormat'),
        icon: <CloseCircleFilled />,
      })
      return;
    }

    const reader = new FileReader()
    reader.onload = event => {
      
      const parts = (event?.target?.result as String).split('\n').map(line => line.split(batchConfig.FileSeparator));

      if (parts.some(p => Object.keys(p).length > 1 && Object.keys(p).length !== columns.length)){
        Modal.error({
          title: t('fileErrorTitle'),
          content: t('fileErrorIncorrectContent', {columnSize: columns.length}),
          icon: <CloseCircleFilled />,
        })
        return;
      }

      const mapParts = parts.filter(p => Object.keys(p).length === columns.length).map((p, index) => {
        let newEl: any = {};
        newEl['key'] = index;
        columns.forEach((c: any, index: number, array: Array<any>) => {          
          index === array.length - 1 ? newEl[c.key] = p[index].replace('\r', '') : newEl[c.key] = p[index];
        });
        return newEl;
      }
      );
      setData([...mapParts]);
    }
    reader.readAsText(file.file);
  };

  const generateFile = () => {
    const finalText = data.map(({ key, ...keepAttrs }) => keepAttrs).reduce((previous, current) => previous + Object.values(current).join(batchConfig.FileSeparator) + '\n', []).slice(0, -1);
    const blob = new Blob([finalText], {
      type: "text/plain;charset=utf-8"
    });
    saveAs(blob, `batch.${batchConfig.FileFormat}`);
  }

  React.useEffect(() => {
    if (Object.keys(transfer).length > 0) {
      showModal();
    }
  }, [transfer, columns]);  

  let params = new URLSearchParams(document.location.search.substring(1));
  const languageParam = params.get("language");
  if (languageParam && languageParam !== i18next.language){
    i18next.changeLanguage(languageParam);
  }

  return (
    <Layout>
      <TransferModal columns={columns} modalVisible={modalVisible} setModalVisible={setModalVisible} addTransfer={addTransfer} resetTransfer={resetTransfer} transfer={transfer} />
      <Header className="site-layout-sub-header-background" style={{ padding: 0 }}>
        <div className="logo">
          <img src="/logo.svg" alt="Logo" />
        </div>
        <Menu mode="horizontal" defaultSelectedKeys={[batchFileType]}>
          {batchFilesPerCountry.find(f => f.Country === country)?.BatchTypes.map(b => {
          return (<Menu.Item key={b}><a href={`/${country}/${b}` + (languageParam !== null ? `?${params.toString()}` : '')}>{t(b.toLowerCase())}</a></Menu.Item>)
          })}
        </Menu>
      </Header>
      <Content style={{ margin: '24px 0' }}>
        <Row gutter={[0, 24]}>
          <Col span={8}><Upload beforeUpload={() => false} showUploadList={false} onChange={(file: any, fileList: any) => fileUploadHandler(file, fileList)} ><Button type={'primary'} icon={<UploadOutlined />}>{t('loadFile')}</Button></Upload></Col>
          <Col span={8} offset={8}><Button icon={<PlusOutlined />} type={'primary'} style={{ float: 'right' }} onClick={showModal}>{t('addTransfer')}</Button></Col>
        </Row>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <TransferTable columns={columns} data={data} removeTransfer={removeTransfer} editTransfer={editTransfer} />
          </Col>
        </Row>
        <Row>
          <Col data={data} span={24}>
            <Button disabled={data.length === 0} onClick={generateFile} icon={<ExportOutlined />} type={'primary'} style={{ float: 'right' }}>{t('generateFile')}</Button>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
}

export default App;
